import { NgModule } from '@angular/core';
import { RouterStateSerializer } from '@ngrx/router-store';
import { PRODUCT_NORMALIZER, PRODUCT_SEARCH_PAGE_NORMALIZER } from '@spartacus/core';
import {
  CustomOccProductSearchPageNormalizer,
  CustomRouterStateSerializer,
  OccShopNormalizer,
  PASCAL_TO_CAMEL_CASE_NORMALIZER,
  PascalToCamelCaseNormalizer,
  ProductIsRentNormalizer,
  ProductUriNameNormalizer,
  SHOPS_NORMALIZER,
} from './converters';

@NgModule({
  providers: [
    {
      provide: SHOPS_NORMALIZER,
      useExisting: OccShopNormalizer,
      multi: true,
    },
    {
      provide: PASCAL_TO_CAMEL_CASE_NORMALIZER,
      useExisting: PascalToCamelCaseNormalizer,
      multi: true,
    },
    {
      provide: RouterStateSerializer,
      useClass: CustomRouterStateSerializer,
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductUriNameNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductIsRentNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_SEARCH_PAGE_NORMALIZER,
      useExisting: CustomOccProductSearchPageNormalizer,
      multi: true,
    },
  ],
})
export class CoreUtilsModule {}
